import 'bootstrap/dist/css/bootstrap.min.css';

export function HomePage() {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-sm border-0">
            <div className="card-body p-5 text-center">
              <h1 className="display-4 fw-bold text-primary mb-3">TextMeLater</h1>
              <p className="lead mb-4">Schedule messages to your phone easily and reliably. Set up one-time, daily, weekly, monthly, or yearly reminders with flexible options.</p>
              <p className="mb-4">Sign up or sign in using the buttons in the top right to get started!</p>
              <div className="d-flex justify-content-center gap-3">
                <span className="badge bg-primary">Secure</span>
                <span className="badge bg-success">Easy to Use</span>
                <span className="badge bg-info">Flexible Scheduling</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
